import { render, staticRenderFns } from "./KarmaCatalogueEdit.vue?vue&type=template&id=eb01e852&"
import script from "./KarmaCatalogueEdit.vue?vue&type=script&lang=js&"
export * from "./KarmaCatalogueEdit.vue?vue&type=script&lang=js&"
import style0 from "./KarmaCatalogueEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports